import React from 'react';
import { Col, Row, Input, Label } from 'reactstrap';
import del from '../../../Res/Icon/delete.png';

export default function ForwardNumber({ fwdNumber, handleChange, fwdCheck, onDeleteFwdNumber }) {
  return (
    <>
      <Row>
        <Label for="name" sm={4}>
          Forward Number:
        </Label>
      </Row>
      <Row>
        <Col sm={12} md={6}>
          <Input
            value={fwdNumber}
            disabled={!fwdCheck}
            required
            type="text"
            placeholder="Forward Number"
            name="fwdNumber"
            maxLength={12}
            onChange={e => {
              handleChange(e.target.value);
            }}
          />
        </Col>

        <Col hidden={fwdCheck} md={1} style={{ padding: '0px' }}>
          <img className="actions-icon" src={del} alt="delete" onClick={onDeleteFwdNumber} />
        </Col>
      </Row>
    </>
  );
}
